const isDevelopment = process.env.REACT_APP_BUILD_ENV === "development";
export const ENV = {
  API: isDevelopment
    ? "https://api.digiattar.rgbgroup.ir/api/backend"
    : "https://api.digiattar.com/api/backend",

  STORAGE:
    process.env.REACT_APP_STORAGE_URL ||
    "https://api.digiattar.com/api/backend",

  k: process.env.REACT_APP_ENCRYPTION_KEY || "c0ff70cc197a07dff1fb709688170426",
  i: process.env.REACT_APP_ENCRYPTION_IV || "f8b4e45085a1045902c3c69c80e67a7c",

  TinyMCEApiKey:
    process.env.REACT_APP_TINYMCE_API_KEY ||
    "1iu7rhp54lw7udhv0zn9l9rzyu98jy5w97f742h8zgpt6i5f",

  captcha:
    process.env.REACT_APP_CAPTCHA_SITE_KEY ||
    "6LdgBBMaAAAAAGqvXz31pzkg6Xu5s-9G-pTVnofv",
};
